import * as Protocol from '../message/protocol.js';
var KeepAlive = /** @class */ (function () {
    function KeepAlive(socket, timeoutMs) {
        this.socket = socket;
        this.timeoutMs = timeoutMs;
    }
    KeepAlive.prototype.start = function () {
        var _this = this;
        if (this.interval) {
            clearInterval(this.interval);
        }
        this.interval = setInterval(function () {
            _this.socket.send(Protocol.encodeMessage({
                type: '__PingMessage',
                action: 'ping',
                service: 'root',
            }));
        }, this.timeoutMs);
    };
    KeepAlive.prototype.stop = function () {
        if (this.interval) {
            clearInterval(this.interval);
        }
    };
    return KeepAlive;
}());
export { KeepAlive };
